import React, { useState } from 'react'
import { connect } from 'react-redux'
import PT from 'prop-types'
import { hide, show } from 'store/modals'
import { Text } from 'components/v2/styled'
import styled from 'styled-components'
import StyleableModal from 'components.v2/Modal/StylableModal'
import Icon from 'components/Icon.v2'

export const Container = styled.div`
  max-width: 550px; 
  height: 288px; 
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
`

const ButtonGroup = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 68px;
  border-top: 1px solid #E6E6E6;
`

const Input = styled.input`
  height: 48px;
  border-radius: 8px;
  background: #F2F2F2;
  margin-bottom: 40px;
  width: 100%;
  padding: 14px 16px;
  color: #000;

  /* Web - Paragraph */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  outline: none;
`

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  text-align: center;
  outline: none;

  /* Web - Paragraph */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  &:first-child {
    border-right: 1px solid #E6E6E6;
  }

  &:disabled {
    color: #E6E6E6;
  }
`


/**
 * PromoCodeModal
 *
 * Expects `data` prop shaped like:
 * {
 *   heading: string,
 *   subHeading: string,
 *   placeholder: string,
 *   buttonLabel: string,          // label for redeem button (optional)
 *   onRedeem: (code: string) => void // optional callback
 * }
 */
const PromoCodeModal = ({ hide, data = {} }) => {
  const {
    heading = 'Got a promo code?',
    subHeading = 'Enter your unique voucher code to redeem your promotion',
    placeholder = 'Enter promo code',
    buttonLabel = 'Redeem',
    onRedeem,
  } = data

  const [code, setCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleHide = () => hide()

  const handleRedeem = async () => {
    console.log("on redeem",onRedeem)
    if (!code) return hide()
    if (typeof onRedeem === 'function') {
      try {
        setIsLoading(true)
        await onRedeem(code)
        setIsLoading(false)
        return hide()
      } catch (err) {
        // swallow — parent can show errors via redux/toast
        // eslint-disable-next-line no-console
        setIsLoading(false)
        console.error('onRedeem error', err)
        return hide()
      }
    }
  }

  return (
    <Modal
      isOpen
      contentLabel="Promo Code"
      onRequestClose={handleHide}
      prependClassName="text-left"
      small
      noCloseButton
    >
      <Container className='p-40'>

        <div>
          {/* Heading */}
          {heading && <Text size="24px" fontWeight="700" height="28px" color="#000">{heading}</Text>}

          {/* Subheading (muted) */}
          {subHeading && (
            <Text color="#999" size="14px" fontWeight="500" height="20px">
              {subHeading}
            </Text>
          )}
        </div>

        {/* Large rounded input */}
        <Input
          aria-label="Promo code input"
          placeholder={placeholder}
          value={code}
          onChange={e => setCode(e.target.value)}
        />

        {/* Footer with two equal buttons */}
        <ButtonGroup>
          
          <Button className='flex-1'
            onClick={handleHide}>
            Cancel
          </Button>
          <Button className='flex-1'
            onClick={handleRedeem}
            disabled={!code.trim() || isLoading}
            
          >
            {isLoading ? 'Verifying...' : buttonLabel}
          </Button>
        </ButtonGroup>
      </Container>
      
    </Modal>
  )
}

PromoCodeModal.propTypes = {
  show: PT.func,
  hide: PT.func.isRequired,
  data: PT.shape({
    heading: PT.string,
    subHeading: PT.string,
    placeholder: PT.string,
    buttonLabel: PT.string,
    onRedeem: PT.func,
  }),
}

const withContainer = connect(
  () => ({}),
  { show, hide },
)

export default withContainer(PromoCodeModal)


const Modal = ({
  children,
  noCloseButton,
  small,
  onRequestClose,
  ...props
}) => (
  <ModalCmpt small={small} onRequestClose={onRequestClose} {...props}>
    {!noCloseButton && <CloseButton onClick={onRequestClose} />}
    {children}
  </ModalCmpt>
)

const ModalCmpt = styled(StyleableModal)`
  &__content {
    position: relative;
    display: block;
    max-width: 550px;
    width: ${p => (p.small ? 'calc(100vw - 60px)' : 'calc(100vw - 30px)')};
    background-color: ${p => p.theme.colors.white};
    outline: none !important;
    border-radius: 12px;
  }

  &__overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.66);
    position: fixed;
    z-index: 10000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`
const CloseButton = styled(p => (
  <button>
    <Icon type="close" {...p} />
  </button>
))`
  position: absolute;
  top: 20px;
  right: 20px;
  color: ${p => p.theme.colors.gray3};
  font-size: 18px;
`

